import { render, staticRenderFns } from "./SingleClientSelectSector.vue?vue&type=template&id=13950994&"
import script from "./SingleClientSelectSector.vue?vue&type=script&lang=js&"
export * from "./SingleClientSelectSector.vue?vue&type=script&lang=js&"
import style0 from "./SingleClientSelectSector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports